import { useCallback } from 'react';
import { risksAPI } from 'services/swagger-api/riskApi';
import { contractualizationStore } from '../store/contractualizationStore';
import { isQuoteContractualizationResponse, mapQuoteResponseToData } from '../utils/mappers';
import { useQuoteContractualizationData } from '../store';

/**
 * Hook pour refetcher les données de contractualisation directement via le store Zustand.
 * Utilisable depuis n'importe quel composant (y compris dans un Panel/Portal)
 * sans dépendance au SubscriptionProcessContext (React Context).
 */
export const useRefetchQuoteData = () => {
  const quoteData = useQuoteContractualizationData();

  return useCallback(async () => {
    if (!quoteData?.riskId) return;

    try {
      const response = await risksAPI.getSubscriptionProcess({
        riskId: quoteData.riskId,
        devisId: quoteData.quoteId
      });

      if (response && isQuoteContractualizationResponse(response.contractualizationData)) {
        const mappedData = mapQuoteResponseToData(
          response.contractualizationData,
          response.riskId || quoteData.riskId,
          response.folderIdentifier,
          response.branchCode
        );
        contractualizationStore.actions.setQuoteData(mappedData);
      }
    } catch (error) {
      console.error('[useRefetchQuoteData] Erreur refetch:', error);
    }
  }, [quoteData?.riskId, quoteData?.quoteId]);
};
